import { CampaignType, ICampaignRoulette } from "@/@types/campaign-roulette";
import { STORE_CODE_VALUES } from "@/pages/crm/campaign-roulette/constants/store-options";
import { transformProbabilitiesToPercentage } from "@/pages/crm/campaign-roulette/utils/probability-utils";
import { type UpdateCampaignRouletteFormData } from "@/pages/crm/campaign-roulette/validations/campaign-roulette.validation";

const toDateInput = (value?: string) => (value ? value.split("T")[0] : "");

/**
 * Converte a campanha vinda do backend nos valores controlados do formulário de edição.
 * Usado com a opção `values` do react-hook-form, dispensando reset() em useEffect.
 */
export const buildEditCampaignFormValues = (
  campaign: ICampaignRoulette
): UpdateCampaignRouletteFormData => {
  const stores = (campaign.stores ?? []).map((store) => {
    const isAllStores = store.storeCode === STORE_CODE_VALUES.ALL_STORES_CODE;
    return {
      storeCode: store.storeCode,
      storeName: isAllStores ? "" : store.storeName || "",
      nickname: isAllStores ? "" : store.nickname || store.storeName || "",
    };
  });

  const allStoresSelected =
    stores.length === 1 &&
    stores[0].storeCode === STORE_CODE_VALUES.ALL_STORES_CODE;

  return {
    id: campaign.id,
    campaignName: campaign.nickname,
    campaignType: campaign.campaignType ?? CampaignType.ROULETTE,
    startDate: toDateInput(campaign.startDate),
    endDate: toDateInput(campaign.endDate),
    stores,
    probabilities: transformProbabilitiesToPercentage(campaign.probabilities ?? []),
    allStoresSelected,
    linkedCampaignId: campaign.linkedCampaignId ?? null,
  };
};
